import { FmlxCheckBox, FmlxTableCell, FmlxTableRow } from 'fmlx-common-ui';
import React from 'react';
import { CaptureProfileOption } from './ExperimentReportOptions';
import { HitsReportCaptureProfileColumnDef } from './HitsReportCaptureProfileTable.types';

type HitsReportCaptureProfileTableRowProps = {
  id: string;
  rowIndex: number;
  profile: CaptureProfileOption;
  columns: HitsReportCaptureProfileColumnDef[];
  selectedCount: number;
  onProfileChange: (checked: boolean, profile: CaptureProfileOption) => void;
};

const HitsReportCaptureProfileTableRow = ({
  id,
  rowIndex,
  profile,
  columns,
  selectedCount,
  onProfileChange,
}: HitsReportCaptureProfileTableRowProps) => {
  const isMaxSelectionReached = selectedCount >= 2 && !profile.selected;

  return (
    <FmlxTableRow
      id={`${id}-fmlxtablerow-${rowIndex}`}
      key={`${id}-fmlxtablerow-${rowIndex}`}
      onClick={null}
      sx={{
        height: 40,
        borderBottom: 'none',
        '& td': { borderBottom: 'none' },
      }}
    >
      {columns.map((column) => {
        if (column.id === 'selected') {
          return (
            <FmlxTableCell
              id={`${id}-fmlxtablecell-selected-row${rowIndex}`}
              key={`${id}-fmlxtablecell-selected-row${rowIndex}`}
              align={column.textAlign ?? 'right'}
              sx={{ borderBottom: 'none' }}
            >
              <div className="flex w-full justify-end">
                <FmlxCheckBox
                  id={`${id}-fmlxcheckbox-row${rowIndex}`}
                  checked={profile.selected}
                  disabled={isMaxSelectionReached}
                  onChange={(e) => onProfileChange(e.target.checked, profile)}
                  size={FmlxCheckBox.Size.SMALL}
                />
              </div>
            </FmlxTableCell>
          );
        }

        return (
          <FmlxTableCell
            id={`${id}-fmlxtablecell-name-row${rowIndex}`}
            key={`${id}-fmlxtablecell-name-row${rowIndex}`}
            align={column.textAlign ?? 'left'}
            sx={{ borderBottom: 'none' }}
          >
            <span className="text-xs whitespace-nowrap">{profile.name}</span>
          </FmlxTableCell>
        );
      })}
    </FmlxTableRow>
  );
};

export default HitsReportCaptureProfileTableRow;
